import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function Divider({ className }) {
    return (_jsx("hr", { className: clsx("w-full h-0.5 border-t-0 bg-border", className) }));
}
//# sourceMappingURL=Divider.js.map